import React from 'react'
import Breadcrumb from "../../utility/breadcrumb/Breadcrumb";
import DatePicker from "../../utility/datepicker/DatePicker";
import AjaxSelect from "./AjaxSelect";

const CommonComponent = ({ onRangeChange, defaultRange, categoryName, categoryId, onBreadcrumbClick, viewType }) => {
  const MIN_DATE = localStorage.getItem('min_date') ? new Date(localStorage.getItem('min_date')) : null;
  const MAX_DATE = localStorage.getItem('max_date') ? new Date(localStorage.getItem('max_date')) : null;
  const isDashboardReady = localStorage.getItem('dashboard-ready') === 'true' || localStorage.getItem('dashboard-ready') === true;

  return (
    <div className="container-fluid common-component-header breadcrumb-common-header" style={{paddingTop:"0px !important"}}>
      <div className="row align-items-center gy-3">
        {/* Breadcrumb */}
        <div className="col breadcrumb-col" style={{overflow:"hidden"}}>
          <Breadcrumb
            title="Dashboard"
            categoryName={categoryName}
            categoryId={categoryId}
            onBreadcrumbClick={onBreadcrumbClick}
            defaultRange={defaultRange}
            viewType={viewType}
          />
        </div>
        {/* DatePicker */}
        {isDashboardReady && (
          <div className="col-auto datepicker-col">
            <div className='ajax-mobile-section d-none text-start' style={{ minWidth: "150px" }}>
              <AjaxSelect
                id="marketplace-selectm"
              />
            </div>
            <DatePicker
              onChange={onRangeChange}
              defaultRange={defaultRange}
              minDate={MIN_DATE}
              maxDate={MAX_DATE}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonComponent;
